import React from 'react';
import { PlatformKBWithContext } from '@wealthlane/chatbot';
import { DynamicTableV2 } from '@packages/table-builder';
import { ModalSheet } from '@packages/ui/composites';
import { axiosInstance } from '../../services/apiInterceptor';
import { toast } from 'react-toastify';
import Heading from '../typography';
import { PageHeader } from '../../constants/style/common.styled';
import ToastComponent from '../toast';
import useInstance from '../../hooks/custom-hooks/useInstance';
import { configState } from '../chatbot/config';
import { getTenantId } from '@apps/customer/utils/tenantHelpers';

export function PlatformKB() {
  const { getCurrentCid } = useInstance();
  const cid = getCurrentCid();
  const apiBase =
    process.env.REACT_APP_PLATFORM_KB_API ||
    (process.env.REACT_APP_CHATBOT_REST_URL
      ? `${process.env.REACT_APP_CHATBOT_REST_URL}/api/kb`
      : '');

  return (
    <>

      <PlatformKBWithContext
        axiosInstance={axiosInstance}
        config={configState}
        companyId={cid?.toString?.() ?? ''}
        tenantIdAccessor={getTenantId}
        alertFunctionSuccess={(message: string) =>
          toast.success(<ToastComponent label="Success" message={message} />)
        }
        alertFunctionError={(message: string) =>
          toast.error(<ToastComponent label="Error" message={message} />)
        }
        apiBase={apiBase}
        platformKBTableComponent={DynamicTableV2}
        platformKBModalComponent={ModalSheet}
      />
    </>
  );
}

export default PlatformKB;
